import { useSelector } from "react-redux";
import { selectTakes3D, selectTakes360, selectAllPropPresets } from "../app/slices/TrainingSlice";
import { getPropReferences } from "../helpers/PropReferences";
import { Prop } from "../models/Prop";

export default function useProjectSafety() {
  const allTakes = useSelector(selectTakes3D) ?? [];

  const props = useSelector(selectAllPropPresets) ?? [];
  const takes360 = useSelector(selectTakes360) ?? [];
  const getPropReferencesInProject = (target: Prop) =>
    getPropReferences({ props, takes3D: allTakes, takes360 }, target.id);
  const propHasReferencesInProject = (target: Prop) =>
    getPropReferencesInProject(target).length > 0;

  const actorHasReferencesInProject = (npcInstanceId: string) => {
    return allTakes.some((take) => {
      return take.actors.some((actor) => actor.actorId === npcInstanceId);
    });
  };

  return { propHasReferencesInProject, getPropReferencesInProject, actorHasReferencesInProject };
}
